import {
  getIpeWorkspaceMode,
  isCreditsInsufficientError,
  isStorageInsufficientError,
  isStoragePlatformFullError,
} from '@/utils/api';
import {
  sanitizeIpeUserMessage,
  toIpeUserErrorMessage as sanitizeToUserMessage,
} from '@/utils/ipeErrorSanitizer';
import { logIpeClientError } from '@/utils/ipeClientErrorLogger';
import { workspaceScopeLabel } from '@/pages/ipe/workbench/utils/accountCenterUtils';

/**
 * IPE 工具系统统一错误处理
 * HTTP 层错误已由 api.js 全局拦截器脱敏；此处处理业务层 catch 与非 HTTP 错误
 */

export { isCreditsInsufficientError, isStorageInsufficientError, isStoragePlatformFullError };
export { sanitizeIpeUserMessage };

export function toIpeUserErrorMessage(error, defaultMessage = '操作失败，请稍后重试') {
  const label = workspaceScopeLabel(getIpeWorkspaceMode());
  if (isCreditsInsufficientError(error)) {
    return sanitizeIpeUserMessage(error.message, `当前${label}IPE豆不足，请充值后再试`);
  }
  if (isStorageInsufficientError(error)) {
    return sanitizeIpeUserMessage(error.message, `当前${label}图片空间容量不足，上传失败`);
  }
  if (isStoragePlatformFullError(error)) {
    return sanitizeIpeUserMessage(error.message, '平台存储空间不足，上传失败，请稍后再试');
  }
  return sanitizeToUserMessage(error, defaultMessage);
}

export function getIpeErrorMessage(error, defaultMessage = '操作失败，请重试') {
  return toIpeUserErrorMessage(error, defaultMessage);
}

/**
 * 业务 catch 统一处理：若全局拦截器未记录则补录日志，并返回用户可见文案
 */
export function handleIpeError(context, error, defaultMessage = '操作失败，请重试') {
  const userMessage = toIpeUserErrorMessage(error, defaultMessage);
  if (!error?.ipeIntercepted) {
    logIpeClientError(context, error, userMessage);
  }
  return userMessage;
}
